module.exports = __webpack_public_path__ + "fonts/facebook-dark-2.e658677.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-dark-2.svg
// module id = 874
// module chunks = 0